<template>
  <div id="app">
    <router-view />
    <CookieBanner />
  </div>
</template>

<script>
import { onMounted, watch, nextTick, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useSettingsStore } from '@/store/settings'
import { useCookieConsent } from '@/stores/cookieConsent'
import CookieBanner from '@/components/CookieBanner.vue'

export default {
  name: 'App',
  components: {
    CookieBanner
  },
  setup() {
    const route = useRoute()
    const settingsStore = useSettingsStore()

    const initSal = () => {
      // Wait for DOM to be fully updated
      nextTick(() => {
        setTimeout(() => {
          if (typeof sal !== 'undefined') {
            // Reset all sal elements first
            const salElements = document.querySelectorAll('[data-sal]')
            salElements.forEach(el => {
              el.classList.remove('sal-animate')
            })
            
            // Re-initialize SAL fresh
            sal({
              once: true,
              threshold: 0.1
            })
          }
        }, 300)
      })
    }

    // Dinamik favicon ayarlama - tüm boyutlar için
    const updateFavicons = (settings) => {
      if (!settings) return
      
      const defaultFavicon = settings.favicon
      if (!defaultFavicon) return
      
      // Helper: Link elementi oluştur veya güncelle
      const setFaviconLink = (rel, sizes, href) => {
        if (!href) return
        let link = document.querySelector(`link[rel="${rel}"]${sizes ? `[sizes="${sizes}"]` : ''}`)
        if (!link) {
          link = document.createElement('link')
          link.rel = rel
          if (sizes) link.sizes = sizes
          document.head.appendChild(link)
        }
        link.href = href
      }
      
      // 16x16 - Tarayıcı sekmesi
      setFaviconLink('icon', '16x16', settings.favicon_16 || defaultFavicon)
      
      // 32x32 - Tarayıcı sekmesi (retina)
      setFaviconLink('icon', '32x32', settings.favicon_32 || defaultFavicon)
      
      // Varsayılan favicon (shortcut icon)
      let shortcutIcon = document.querySelector('link[rel="shortcut icon"]')
      if (!shortcutIcon) {
        shortcutIcon = document.createElement('link')
        shortcutIcon.rel = 'shortcut icon'
        document.head.appendChild(shortcutIcon)
      }
      shortcutIcon.href = settings.favicon_32 || settings.favicon_16 || defaultFavicon
      
      // 180x180 - Apple touch icon
      setFaviconLink('apple-touch-icon', '180x180', settings.favicon_apple || defaultFavicon)
      
      // Manifest için meta tag (Android Chrome & PWA)
      // Not: manifest.json dosyası ayrıca oluşturulmalı
    }

    // Settings değiştiğinde favicon'ları güncelle
    const settings = computed(() => settingsStore.settings)
    watch(settings, (newSettings) => {
      if (newSettings?.favicon) {
        updateFavicons(newSettings)
      }
    }, { immediate: true, deep: true })

    // Cookie consent store
    const cookieConsent = useCookieConsent()

    // Initialize SAL on mount
    onMounted(async () => {
      // Settings ve menüleri paralel yükle
      const lang = route.params.lang || 'tr'
      await Promise.all([
        settingsStore.loadSettings(),
        settingsStore.loadMenus(lang)
      ])
      
      // Favicon'ları ayarla
      if (settingsStore.settings?.favicon) {
        updateFavicons(settingsStore.settings)
      }
      
      // Cookie consent durumunu yükle ve analytics'i başlat
      const consent = cookieConsent.loadConsent()
      if (consent === 'accepted') {
        // Analytics ID'leri settings'den al ve yükle
        const gaId = settingsStore.settings?.google_analytics_id
        const fbPixelId = settingsStore.settings?.facebook_pixel_id
        
        if (gaId) {
          cookieConsent.loadGoogleAnalytics(gaId)
        }
        if (fbPixelId) {
          cookieConsent.loadFacebookPixel(fbPixelId)
        }
      }
      
      // SAL'ı başlat
      initSal()
    })

    // Re-initialize SAL on route change
    watch(() => route.path, () => {
      initSal()
    })

    return {}
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>










